export default {
    // 基本文案
    base: {
        // loading页点击提示
        loading_tapTips: 'Tap the egg to start',
        // 活动按钮
        rule_btn: 'Rules ',
        // 下载按钮
        download_btn: 'Download',
        // 下载提示窗的slogan
        download_slogan:
            'Master, take me to fight in King of Avalon and win more rewards!',
        // 取消按钮
        cancel_btn: 'cancel',
        // 关闭按钮
        close_btn: 'close',
        // 确认按钮
        confirm_btn: 'confirm',
        // 兑换按钮
        redeem_btn: 'REDEEM',
        // 分享图片
        share_img: 'Share',
        // 换一只领养
        changeDragon: 'Change Dragon',
        // 确认领养并且对战
        adoptBattle: 'Adopt and battle',
        // 查看战力说明
        score_rule_btn: 'Power Info',
        // 中奖记录按钮
        record_btn: 'Reward record',
        // 总战力
        totalPower: 'Total Power',
        // 未兑换战力
        unredeemedPower: 'Unredeemed Power',
        // 积分奖励
        scorePrize: {
            get_gift_one: 'Claim $20 Gift Bundle', // 奖励文案
            get_gift_two: 'Claim $20 Gift Bundle', // 奖励文案
            draw: 'Lucky Draw' // 奖励文案
        },
        // 好友页标题
        friendTitle: "<span>%{name}</span>'s <br />battle with friends",
        // loading页slogan
        loadingSlogan: 'Raise a Dragon for<br>the chance to get a Switch!',
        // 暂无好友提示
        friendEmptyTips:
            'Invite more friends <span>to battle</span> and win Power to draw again',
        // 暂无好友对战记录
        norecord_tips: `
            <p>No friends have come yet.</p>
            <p>Tap the Share button to show off your Dragon</p>
            <p>and invite your friends to battle!</p>
            `,
        // 请输入名字
        enter_name: 'Please enter your name',
        // 请输入邮箱
        enter_email: 'Please enter your mailbox',
        // 请输入正确格式邮箱
        enter_right_email: 'Please make sure your mail address is correct',
        // 请输入国家
        enter_country: 'Please enter your nation',
        // 请输入地址
        enter_address: 'Please enter your address',
        // 请输入手机号
        enter_phone: 'Please enter your phone number',
        // 请输入正确格式手机号
        enter_rightr_phone: 'Please enter a correct phone number',
        // 活动结束
        activityEnd: `The KoA Anniversary Dragon event has concluded. All rewards have been drawn. Thank you for participating!
        Some winners might have been too excited and didn't fill in the necessary information for rewards, please go to the <a href="https://www.facebook.com/koadw/" style="color:#6eb7db;text-decoration: underline;">King of Avalon Facebook</a> page to contact us.
        Download <a href="https://app.adjust.com/ts8zich_dz016n6" target="_blank" style="color:#6eb7db;text-decoration: underline;">King of Avalon</a> now to raise your own dragon!`
    },
    popup: {
        // 请输入昵称
        inputNameTips: 'Please enter your name',
        // 生成专属龙
        genDragonTips: 'Spawning your unique Dragon, please wait',
        // 战力不足
        noScoreTips:
            'Insufficient Power. Tap Share and invite more friends to play together and win Power for the lucky draw!',
        // 分享提示
        shareTips: `Invite more friends<br>
        to battle and win<br>
        Power to draw again`,
        // 下载提示
        loginTips: `Please log in, adopt a Dragon,<br>
            and fight for the chance to <br>
           get a Switch & AirPods Pro!`,
        // 活动规则
        rule: {
            title: 'Rules',
            content: `
            <div class="rule-item">
                <h4>1. Event time:</h4> 
                <p>2021/7/14-2021/7/29</p>
            </div>
            <div class="rule-item">
                <h4>2. Rules:</h4>
                <p>Adopt: Players have to log in with Facebook or VK accounts to adopt a Dragon. Every Dragon has a unique image, name, and attributes. After it's spawned, it cannot be changed.
                </p>
                <p>Battle: You can invite your friends to join the game, and after they adopt one, your Dragons will battle automatically and win you both Power points. You can only match 3 times at most with one friend.</p>
                <p>Invite: You can share the game on Facebook/WhatsApp/VK to invite more friends to play together.</p>
                <p>Power: Win a battle to gain 300 points of Power, get 200 points if you lose, and download King of Avalon to win 600 Power. The first 3 clicks of the share link grant you 300 Power each time</p>
            </div>
            <div class="rule-item"> 
                <h4>3. Rewards:</h4>
                <p>a. Reach 300 Power to claim a King of Avalon gift bundle worth $20, and reach 600 Power to claim a gift bundle worth $20. Reach 1000 Power for a lucky draw chance, which could get you a King of Avalon gift bundle worth $20, $10 Amazon Gift Card, $50 Amazon Gift Card, Switch, Sony PS5, or AirPods Pro.</p>
                <p>b. There are a total of 100K Gift Bundles. After you obtain a Gift Code, please enter the game and input the code in Player Profile-Settings-Gift Codes to redeem your gifts. The valid time for the code is 3 months, please claim your rewards on time.</p>
                <p>c. There are a total of 38 Amazon Gift Cards and 8 real item rewards. After you draw a Gift Card or item rewards, please leave your personal information and our staff will contact you within 7 working days after the event finishes.</p>
                <p>d. Gift Cards and item reward winners will be announced on King of Avalon's official Facebook page on July 30, 2021. The winners should provide their personal information before August, 6 by replying to the mail they receive. Failure to reply on time will negate your rewards.</p>
                <p>e. As this event involves real item rewards, an extra fee will be needed for delivery to some remote locations (determined by logistics). If the delivery fails due to incomplete/wrong information submitted by players, there will be no remedy. Furthermore, once the reward items are sent out, loss, collection by mistake, theft, and any other losses of possession during or after the shipment will be at the winner's own risk. We will not take the responsibility for re-sending rewards.</p>
           </div>
            <div class="rule-item">
                <p>4. FunPlus reserves the right of final interpretation of the event. Joining the event means you know and accept the gameplay and rules of the event organized by the hosts. If any violation of rules, disruption of the game's order, or harassment of others are found and verified, we reserve the right to revoke all the rights and qualities of the players.</p>
            </div>
            <div class="rule-item">
                <p>5. Please follow the King of Avalon Facebook page and the official Facebook Group：<a href="https://www.facebook.com/groups/1470553169963869" target="_blank" style="word-break:break-word;"> https://www.facebook.com/groups/1470553169963869</a></p>
            </div>
        `
        },
        // 战力说明
        powerInfo: {
            title: 'Power Info',
            content: `
                    <p>1. Win a battle to win 300 points of Power, get 200 Power if you lose, and download King of Avalon to win 600 Power. The first 3 clicks of the share link grant you 300 Power each time.</p>
                    <p>2. Reach 300 Power to claim a King of Avalon gift bundle worth $20, and reach 600 Power to claim a gift bundle worth $20. Reach 1000 Power for a lucky draw chance, which could get you a King of Avalon gift bundle worth $20, $10 Amazon Gift Card, $50 Amazon Gift Card, Switch, Sony PS5, or AirPods Pro.</p>
                    <p>3. 300/600 Power gifts can only be claimed once, but the Lucky Draw has no limit. 1000 points will be deducted to perform the draw and you'll accumulate Power anew.</p>
                    <p>4. A higher Total Power will give you a higher winning chance. The Power you exchange won't influence battles.</p>
                    <p>5. You can battle a max of 3 times with one friend.</p>
                `
        },
        // 兑换码弹窗
        code: {
            title: `Congratulations!<br>
            You won【%{reward}】`,
            label: 'code',
            // 一键复制按钮
            copy_btn: 'COPY',
            // 跳转兑换按钮
            redeem_btn: 'GO REDEEM',
            // 复制礼包码成功
            copy_success: 'Gift Code copied'
        },
        // 购物卡弹窗
        giftCard: {
            title: `Congratulations!</br>
                You won</br>
                【%{reward}】`,
            desc: `Please leave your information and</br>
        our staff will contact you within 7 working
        days after the event finishes.`,
            name: 'Name',
            country: 'Country',
            email: 'Email</br>address'
        },
        // 实物奖
        entity: {
            title: `Congratulations!</br>
            You won</br>
            【%{reward}】`,
            desc: `Please leave your information and</br>
            our staff will contact you within 7 working
            days after the event finishes.`,
            name: 'Name',
            addr: 'Address',
            mobile: 'Phone<br>Number',
            email: 'Email<br>Address'
        },
        draw: {
            // 中奖资料填写成功
            fillSucc:
                'Submitted! Our staff will contact you within 7 working days after the event finishes.',
            free: `Congratulations! You just completed<br>the first battle and won a free lucky<br>draw chance!`,
            // 未中奖文案
            noReward: `Looks like you didn't get lucky this time. Share the game with more friends to gain Power and draw again!`
        },
        // 好友页
        friend: {
            name: 'Name',
            battles: 'Battles',
            power: 'Power',
            battleAgain: 'Battle<br>Again'
        },
        // 中奖记录
        record: {
            title: 'Reward record',
            record_time: 'Reward time',
            record_name: 'Reward obtained'
        }
    },
    game: {
        slogan: [
            'Come and fight me!',
            'Wanna duel me?',
            "I'm so strong!",
            'Take me to fight!',
            'Share me with your friend to start a battle!',
            'Tap me to talk with me.',
            'I wanna fight!',
            'How do you feel today?',
            "What's your favorite song, Master?",
            'Master, do you know where the Eye of the Sahara is?',
            'The place I want to travel to most is Iceland, what about you?',
            "Don't forget to put on your mask!",
            'I really want a juicy burger! What about you?',
            'Master, do you think I should lose some weight?',
            'Hurrah hurrah hurrah!',
            'Wubba lubba dub dub!',
            "We'll get lucky eventually!",
            'Going to bed early solves 99% of all mortal troubles!',
            'Take it easy!',
            'No one could know everything in the world!',
            "I'll grow to be a real Dragon, one that breathes fire!",
            'Master, do you like playing games? I heard my brothers can be found in King of Avalon!',
            "Morgana, don't think you can get away again this time!",
            "I heard that the mysterious 'Download' button can make you stronger!"
        ]
    },
    msg: {
        // pk次数限制文案
        pklimit:
            'You can only fight a max of 3 times with one friend. Invite more friends to play together and win more Power for the lucky draw!',
        // 长按保存相片提示
        pressimg2savepicture: 'Press and hold to save the picture',
        // 等待文案
        waiting: 'loading...'
    }
};
